import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { CONTRAST, QUARTER_CONTRAST, HALF_CONTRAST } from '../../theme';
import { StaticImg } from '../../ui';

const HeaderBar = styled.div`
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 6px;
  box-shadow: 1px 1px 2px ${QUARTER_CONTRAST};
  z-index: 2;
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Logo = styled(StaticImg)`
  width: 27px;
  padding-right: 8px;
  padding-left: 16px;
`;

const Title = styled.h1`
  padding: 0;
  margin: 0;
  font-size: 22px;
  color: ${CONTRAST};
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const NavContainer = styled.div`
  color: ${HALF_CONTRAST};
  display: flex;
  flex-direction: row;
`;

const NavButton = styled.div`
  cursor: pointer;
  padding: 12px;
  margin: 0;
  font-size: 16px;
  color: ${HALF_CONTRAST};
`;
const NavLink = styled.a`
  cursor: pointer;
  text-decoration: none;
  padding: 12px;
  margin: 0;
  font-size: 16px;
  color: ${HALF_CONTRAST};
  border-right: 1px solid ${QUARTER_CONTRAST};
`;

const mapState = ({
 city, moduleType, navigation, isPublic,
}) => ({
  city,
  moduleType,
  navigation,
  isPublic,
});

export const AppHeader = ({ signOut }) => {
  const {
 city, moduleType, navigation, isPublic,
} = useSelector(mapState);
  const dispatch = useDispatch();
  return (
    <HeaderBar>
      <LogoContainer>
        <Logo src="/dynamo_logo_small_white.png" alt="Dynamo Metrics" />
        <Title>
          {moduleType}
          {city ? `: ${city}` : ''}
        </Title>
      </LogoContainer>
      <NavContainer>
        <NavLink target="_blank" href="https://solutions.munetrix.com/en/knowledge">
          Help
        </NavLink>
        {
          isPublic ? null : (
            <>
              {navigation.map(({ label, href }) => (
                <NavLink key={label} href={href}>
                  {label}
                </NavLink>
              ))}
              <NavButton onClick={signOut}>Log out</NavButton>
            </>
          )
        }
      </NavContainer>
    </HeaderBar>
  );
};
